import styled, { css } from "styled-components";
import { type DisplayProps, type SpaceProps, display, space } from "styled-system";
import * as Type from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import * as Flex from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as Button from "../../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import { getBreakpoint, getDirection } from "../../../../../../../../common-deprecated/themes/common";
import { theme as toyotaTheme } from "../../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";

export const Wrapper = styled(Flex.Row)<{ isMobile?: boolean }>`
    margin: ${toyotaTheme.space[3]}px 0 ${toyotaTheme.space[2]}px;
    padding: ${toyotaTheme.space[2]}px ${toyotaTheme.space[4]}px;
    background-color: ${toyotaTheme.colors.grey1};
    @media ${getBreakpoint("up", "lg")} {
        margin-top: 0;
    }
`;

export const WheelPreview = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
`;

export const ImageWrapper = styled.div<DisplayProps & SpaceProps>`
    position: relative;
    ${display};
    ${space};
`;

export const Badge = styled.div`
    position: absolute;
    top: 7px;
    ${getDirection("left")}: 10px;
    width: 20px;
    height: 20px;
    text-align: center;
    border: 1px solid rgba(32, 32, 32, 0.2);
    border-radius: 10px;
    ${({ theme }) => css`
        color: ${theme.color.primary};
        background: ${theme.color.lightest};
    `};
`;

export const WheelHeader = styled.div`
    padding-left: ${toyotaTheme.space[2]}px;
`;

export const Name = styled.div``;

export const OptionalText = styled.div`
    color: ${toyotaTheme.colors.grey7};
`;

export const AccordionTitle = styled.div<{ isOpen: boolean }>``;

export const Tab = styled.button.attrs({ type: "button" })<{ isActive: boolean }>``;

export const WheelButtonContainer = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    width: 100%;
    margin-top: ${toyotaTheme.space[3]}px;
`;

export const WheelButton = styled.button`
    display: inline-block;
    margin-right: ${toyotaTheme.space[1]}px;
    padding: 0;
    background: none;
    border: none;
`;

export const Card = styled.div`
    position: relative;
    min-height: 100%;
    padding: ${toyotaTheme.space[3]}px ${toyotaTheme.space[3]}px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);
`;

export const Header = styled.div`
    padding: ${toyotaTheme.space[5]}px;
`;

export const Content = styled.div`
    padding: ${toyotaTheme.space[5]}px;
`;

export const Actions = styled.div`
    padding-left: 76px;
    @media ${getBreakpoint("up", "sm")} {
        padding-left: 0;
        text-align: right;
    }
`;

export const FooterActions = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    row-gap: ${toyotaTheme.space[2]}px;
    margin-top: ${toyotaTheme.space[5]}px;

    @media ${getBreakpoint("up", "md")} {
        flex-direction: row;
        column-gap: ${toyotaTheme.space[2]}px;
        row-gap: 0;
    }

    ${Button.Primary},
    ${Button.Secondary} {
        width: 100%;
        @media ${getBreakpoint("up", "md")} {
            width: auto;
        }
    }
`;

export const Categories = styled.div`
    display: flex;
    justify-content: center;
    margin: 0 auto;
    gap: ${toyotaTheme.space[2]}px;

    @supports not (gap: ${toyotaTheme.space[2]}px) {
        & > div:not(:nth-last-child(1)) {
          margin-${getDirection("right")}: ${toyotaTheme.space[2]}px;
        }
      }

    border-bottom: 1px solid ${toyotaTheme.colors.grey2};
    cursor: pointer;
`;

export const Category = styled.div<{ isActive?: boolean }>`
    padding: 0 ${toyotaTheme.space[2]}px ${toyotaTheme.space[1]}px ${toyotaTheme.space[2]}px;

    ${({ isActive }) =>
        isActive &&
        css`
            position: relative;
            font-family: ${toyotaTheme.fonts.semiBold};
            font-weight: 600;
            color: ${toyotaTheme.colors.primaryBlack};
            background-color: transparent;
            border-bottom: 2px solid ${toyotaTheme.colors.primaryRed};
            border-radius: 0;
        `};
`;

export const CategoryName = styled.div`
    margin-bottom: ${toyotaTheme.space[1]}px;
    font-size: 1.6rem;
    color: ${toyotaTheme.colors.primaryBlack};
`;

export const CategoryDescription = styled.div`
    margin-top: ${toyotaTheme.space[1]}px;
    font-size: 1.3rem;
    color: ${toyotaTheme.colors.grey7};
`;

export const Legend = styled.div`
    display: flex; 
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: ${toyotaTheme.space[2]}px;

    .dxp-icon {
        margin-${getDirection("right")}: ${toyotaTheme.space[1]}px;
    }

    ${Type.SmallText} {
        margin-right: ${toyotaTheme.space[3]}px;
        color: ${toyotaTheme.colors.grey7};
        @media ${getBreakpoint("up", "md")} {
            margin: 0;
        }

        &:not(:nth-last-child(1)) {
            margin-${getDirection("right")}: ${toyotaTheme.space[2]}px;
        }
    }
    @media ${getBreakpoint("up", "md")} {
        margin-top: 0;
        text-align: ${getDirection("right")};
    }
`;
